import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@material-ui/core";
import { useStyles } from "@material-ui/pickers/views/Calendar/SlideTransition";
import FilteredTable from "./filteredTable.js";
import {
  getAllCalibrations,
  getFliteredCalibrations,
  removeCalibrationById,
} from "../utils/NetworkHandler.js";
import ImportExportFileButtons from "../import-export/import-export-buttons.js";

export default function AllCalibrationPage({ isDetailedData }) {
  const classes = useStyles();
  const [rowData, setRowData] = useState([]);
  const [filters, setFilters] = useState({
    date: "",
    brand: "",
    model: "",
    manufacturer: "",
    calibrator: "",
  });
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [numberOfAllElements, setNumberOfAllElements] = useState(0);
  const [page, setPage] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const headers = [
    "Godzina",
    "Data",
    "Model",
    "Marka",
    "Producent",
    "Kalibrator",
    "Notatki",
    "Odsłuchy",
    "Opcje",
  ];

  const handleDeleteClick = (deviceId) => {
    setItemToDelete(deviceId);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setItemToDelete(null);
  };

  const updateData = async (filtersToUse = filters) => {
    const { data } = await getFliteredCalibrations({
      ...filtersToUse,
      pageSize: rowsPerPage,
      page: 0,
    });

    setPage(0);
    setRowData(data.content);
    setNumberOfAllElements(data.totalElements);
  };

  const handleConfirmDelete = async () => {
    if (!itemToDelete) {
      return;
    }

    try {
      await removeCalibrationById(itemToDelete);
      await updateData(filters);
    } catch (error) {
      console.error("Błąd podczas usuwania urządzenia:", error);
    } finally {
      handleCloseDialog();
    }
  };

  const inputHandler = async (event, headerKey, isClear) => {
    const value = isClear ? "" : event.target.value;

    const newFilters = {
      ...filters,
      [headerKey]: value,
    };

    setFilters(newFilters);
    await updateData(newFilters);
  };

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);

    const queryParams = {
      ...filters,
      pageSize: rowsPerPage,
      page: newPage,
    };

    const { data } = await getAllCalibrations(queryParams);
    setRowData(data.content);
  };

  const handleChangeRowsPerPage = async (event) => {
    const pageNumber = parseInt(event.target.value, 10);
    setRowsPerPage(pageNumber);

    const queryParams = {
      ...filters,
      pageSize: pageNumber,
      page: 0,
    };

    const { data } = await getAllCalibrations(queryParams);
    setRowData(data.content);
    setNumberOfAllElements(data.totalElements);
    setPage(0);
  };

  useEffect(() => {
    const init = async () => {
      const queryParams = {
        pageSize: rowsPerPage,
        page: 0,
      };

      const { data } = await getAllCalibrations(queryParams);
      setNumberOfAllElements(data.totalElements);
      setRowData(data.content);
    };

    init();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box className={classes.rootContainer}>
      <ImportExportFileButtons updateData={updateData} filters={filters} />

      <FilteredTable
        rowData={rowData}
        headers={headers}
        page={page}
        rowsPerPage={rowsPerPage}
        count={numberOfAllElements}
        inputHandler={inputHandler}
        filters={filters}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        removeHandler={handleDeleteClick}
        isDetailedData={isDetailedData}
        updateData={updateData}
      />

      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>Czy na pewno chcesz usunąć tę kalibrację?</DialogTitle>

        <DialogContent>
          <DialogContentText>Tej operacji nie można cofnąć.</DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Anuluj
          </Button>

          <Button onClick={handleConfirmDelete} color="secondary" autoFocus>
            Usuń
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
